



















































































































































































/* eslint-disable camelcase */

import { mapState } from "vuex";
import InputText from "@/common/components/atoms/InputText.vue";
import InputTextarea from "@/common/components/atoms/InputTextarea.vue";
import InputSelect from "@/common/components/atoms/InputSelect.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import FormLabel from "@/common/components/organisms/FormLabel.vue";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";

import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import {
  required,
  max_value,
  min_value,
  numeric,
  max
} from "vee-validate/dist/rules";

import { Prop, Vue, Component, Ref } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});

extend("max_value", {
  ...max_value,
  message: "{_field_}は {max} 以下でなければなりません。"
});

extend("min_value", {
  ...min_value,
  message: "{_field_}は {min} 以上でなければなりません。"
});

extend("numeric", {
  ...numeric,
  message: "数字で入力してください。"
});

extend("max", {
  ...max,
  message: "{_field_}は {max} 以下でなければなりません。"
});


@Component({
  name: "TheJInputScreen",
  components: {
    InputText,
    InputTextarea,
    InputSelect,
    ButtonMain,
    PointNotation,
    SmallText,
    FormLabel,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheJInputScreen extends Vue {
  @Prop({ type: Number, required: false }) availablePoints!: number;
  @Prop({ type: [String, Array, Number] }) pointsToSend!: string | any | number;
  @Prop({ type: [Number, Boolean], default: false }) maxPoints!:
    | number
    | boolean;
  @Prop({ type: [Number, Boolean], default: false }) minPoints!:
    | number
    | boolean;

  @Prop({ type: Number, default: 1 }) givingType!: number;
  @Prop({ type: String }) defaultMessage: string;
  @Prop({ type: Number }) fixedPoint: number;

  @Ref("form") form!: HTMLFormElement;

  sendPoint = "";
  title = "";
  message = "";
  formUrl = "";
  mLenght = 20;

  pointRulesIndex = "";
  get url() {
    return SITE_MAP.THANKS_POINT_USER_SELECTION;
  }
  get selectPoint(): any {
    if (this.pointTypeOf !== "object") {
      return false;
    }

    const pointsToOption = this.pointsToSend.toString();
    const sub = pointsToOption.includes(",");
    const value = sub
      ? pointsToOption.substring(1, pointsToOption.length - 1)
      : pointsToOption;

    const pointsToOptionArr = value.split(",");

    const optionsArray = pointsToOptionArr.map((res: any) => {
      return { value: res, label: res };
    });

    return {
      current: "",
      options: optionsArray
    };
  }

  get pointsToOption() {
    return this.pointsToSend;
  }

  get pointRules() {
    // 最小値は設定があれば設定値、なければ0以上とする
    const minPoint = this.minPointsC == null ? 0 : this.minPointsC;
    return {
      free: `required|numeric|max_value:${this.availablePoints}|min_value:${minPoint}`,
      availablePointRange: `required|numeric|max_value:${this.maxPointsC}|min_value:${this.minPointsC}`,
      object: `required|max_value:${this.availablePoints}`,
      number: `max_value:${this.availablePoints}`
    };
  }
  get unit() {
    return commons.unit;
  }

  get maxPointsC() {
    return this.maxPoints;
  }

  get minPointsC() {
    return this.minPoints;
  }

  get pointTypeOf() {
    if (this.givingType == 2) {
      return "number";
    } else if (this.givingType == 0) {
      return "free";
    } else if (this.givingType == 1) {
      return "object";
    } else if (this.givingType == 3) {
      return "availablePointRange";
    } else {
      return "free";
    }
  }

  get availablePointRange() {
    const max = this.maxPoints;
    const min = this.minPoints;

    // DX_IC-869 下限が0の場合、画面コメントが表示されていない
    if ((!max && max != 0) || (!min && min != 0)) {
      return false;
    }

    return {
      max,
      min
    };
  }

  get maxLenght() {
    const max = this.mLenght;
    return max;
  }

  get thanksExclusivePoint() {
    return this.availablePoints
  }

  async created() {
    this.formUrl = "/give-thanks-point-confirmation/";

    if (LocalStorage.getItem("points_to_show") !== null) {
      this.sendPoint = LocalStorage.getItem("points_to_show") as string;
      this.title = LocalStorage.getItem("title") as string;
      this.message = LocalStorage.getItem("message") as string;
    }
    await this.initPointRulesIndex();
  }

  submit(ObserverProps: any) {
    ObserverProps.passes(() => {
      const pointsToSend = (this.givingType == 1 ? this.selectPoint.current : (this.givingType == 2 ? this.pointsToSend : this.sendPoint));
      if (pointsToSend > this.availablePoints) {
        alert('送付ポイントが贈与可能ポイントを超えています。');
        return;
      }

      let userData = LocalStorage.getItem("sendToUserData") as any;
      userData = JSON.parse(userData);
      console.log(userData);
      if (this.givingType == 1) {
        LocalStorage.setItem("points_to_send", this.selectPoint.current);
        LocalStorage.setItem("points_to_show", this.selectPoint.current);
      } else if (this.givingType == 2) {
        LocalStorage.setItem("points_to_send", this.fixedPoint.toString());
        LocalStorage.setItem("points_to_show", this.fixedPoint.toString());
      } else {
        LocalStorage.setItem("points_to_show", this.sendPoint);
        LocalStorage.setItem("points_to_send", this.sendPoint);
      }

      LocalStorage.setItem("title", this.title);
      LocalStorage.setItem("message", this.message);
      LocalStorage.setItem("to_user", userData.sendTo.id);
      LocalStorage.setItem(
        "thanks_point_giving_type",
        this.givingType.toString()
      );
      this.form.submit();
    });
  }

  initPointRulesIndex() {
    if (this.givingType == 0) {
      this.pointRulesIndex = "free";
    } else if (this.givingType == 3) {
      this.pointRulesIndex = "availablePointRange";
      this.pointRules.availablePointRange = `required|numeric|max_value:${this.maxPointsC}|min_value:${this.minPointsC}`;
    } else if (this.givingType == 2) {
      this.pointRulesIndex = "number";
    } else if (this.givingType == 1) {
      this.pointRulesIndex = "object";
    } else {
      this.pointRulesIndex = "free";
    }
  }
}
